<div *ngIf="isLoading" class="nf-overlay">
    <svg class="nf-spinner" viewBox="0 0 50 50">
        <circle class="nf-spinner__track" cx="25" cy="25" r="20"></circle>
        <circle class="nf-spinner__arc" cx="25" cy="25" r="20"></circle>
    </svg>
</div>

<div class="filters-accordion">
    <p-accordion value="0">
        <p-accordion-panel value="0" *ngIf="filters && filters.length > 0">
            <p-accordion-header>
                <div class="listing-header">
                    <span class="title">Search Filters</span>
                    <button *ngIf="getFiltersForDialog().length > 0" type="button" class="header-filter-button"
                        (click)="openFilterDialog($event)">
                        <i class="p-icon pi pi-filter"></i>
                        <span>Filters</span>
                    </button>
                </div>
            </p-accordion-header>

            <p-accordion-content class="filters-content">
                <div class="filters-row">
                    <ng-container *ngFor="let filter of getFiltersForAccordion()">
                        <!-- Text Input -->
                        <input *ngIf="filter.type === 'text'" [(ngModel)]="filterValues[filter.key]"
                            [placeholder]="filter.placeholder || ''" type="text" pInputText
                            class="dynamic-listing-filter-input" (keydown.enter)="applyFilters()" />

                        <!-- Date Picker -->
                        <p-datepicker *ngIf="filter.type === 'date'" [(ngModel)]="filterValues[filter.key]"
                            [placeholder]="filter.placeholder || ''" size="small" showIcon iconDisplay="input"
                            [showClear]="true" dateFormat="dd/mm/yy" (onSelect)="applyFilters()"
                            (onClear)="applyFilters()"></p-datepicker>

                        <!-- Select Dropdown -->
                        <p-select *ngIf="filter.type === 'select'" [(ngModel)]="filterValues[filter.key]"
                            [placeholder]="filter.placeholder || ''" size="small" [options]="filter.options || []"
                            [optionLabel]="filter.optionLabel || 'label'" [optionValue]="filter.optionValue || 'value'"
                            [showClear]="true" [loading]="filter.loading || false" (onChange)="applyFilters()">
                        </p-select>

                        <!-- Autocomplete -->
                        <p-autocomplete *ngIf="filter.type === 'autocomplete'" [(ngModel)]="filterValues[filter.key]"
                            [placeholder]="filter.placeholder || ''" [suggestions]="filter.suggestions || []"
                            [optionLabel]="filter.optionLabel || 'label'" [optionValue]="filter.optionValue || 'value'"
                            [dropdown]="filter.dropdown !== false" [forceSelection]="filter.forceSelection !== false"
                            [showClear]="true" size="small" class="filter-autocomplete"
                            (onDropdownClick)="onAutocompleteDropdownClick($event, filter)"
                            (keydown.enter)="onAutocompleteEnterKey($event, filter)"
                            (onSelect)="onAutocompleteSelect($event, filter)" (onClear)="onAutocompleteClear(filter)">
                        </p-autocomplete>

                        <!-- Number Input -->
                        <input *ngIf="filter.type === 'number'" [(ngModel)]="filterValues[filter.key]"
                            [placeholder]="filter.placeholder || ''" type="number" pInputText
                            (keydown.enter)="applyFilters()" />
                    </ng-container>
                </div>
            </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>
</div>

<!-- Filter Dialog -->
<p-dialog *ngIf="getFiltersForDialog().length > 0" [(visible)]="displayFilterDialog" [modal]="true" [closable]="false"
    styleClass="filter-dialog">
    <ng-template pTemplate="header">
        <div class="dialog-header">
            <span class="dialog-title">Filters</span>
            <button type="button" pButton icon="pi pi-times" class="dialog-close-button"
                (click)="displayFilterDialog = false" [text]="true" [rounded]="true"></button>
        </div>
    </ng-template>

    <div class="p-dialog-content">
        <div class="content-section">
            <div class="col-grid-6">
                <ng-container *ngFor="let filter of getFiltersForDialog()">
                    <!-- Text Input -->
                    <input *ngIf="filter.type === 'text'" [(ngModel)]="filterValues[filter.key]"
                        [placeholder]="filter.placeholder || ''" type="text" pInputText />

                    <!-- Date Picker -->
                    <p-datepicker *ngIf="filter.type === 'date'" [(ngModel)]="filterValues[filter.key]"
                        [placeholder]="filter.placeholder || ''" size="small" showIcon iconDisplay="input"
                        [showClear]="true" dateFormat="dd/mm/yy" />

                    <!-- Select Dropdown -->
                    <p-select *ngIf="filter.type === 'select'" [(ngModel)]="filterValues[filter.key]"
                        [placeholder]="filter.placeholder || ''" size="small" [options]="filter.options || []"
                        [optionLabel]="filter.optionLabel || 'label'" [optionValue]="filter.optionValue || 'value'"
                        [showClear]="true" [loading]="filter.loading || false">
                    </p-select>

                    <!-- Autocomplete -->
                    <p-autocomplete *ngIf="filter.type === 'autocomplete'" [(ngModel)]="filterValues[filter.key]"
                        [suggestions]="filter.suggestions || []" [placeholder]="filter.placeholder || ''"
                        [showClear]="true" [dropdown]="filter.dropdown !== false"
                        [forceSelection]="filter.forceSelection !== false" [optionLabel]="filter.optionLabel || 'label'"
                        [optionValue]="filter.optionValue || 'value'"
                        (onDropdownClick)="onAutocompleteDropdownClick($event, filter)"
                        (keydown.enter)="onAutocompleteEnterKey($event, filter)" (onSelect)="applyFilters()"
                        (onClear)="applyFilters()">
                    </p-autocomplete>

                    <!-- Number Input -->
                    <input *ngIf="filter.type === 'number'" [(ngModel)]="filterValues[filter.key]"
                        [placeholder]="filter.placeholder || ''" type="number" pInputText />


                </ng-container>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="dialog-footer">
            <button type="button" pButton label="Clear" class="footer-button footer-cancel-button"
                (click)="clearFilters()"></button>
            <button type="button" pButton label="Apply" class="footer-button footer-apply-button"
                (click)="applyFilters()"></button>
        </div>
    </ng-template>
</p-dialog>

<div class="table-actions" *ngIf="showExportButtons || showPagination">
    <div class="table-actions-left" *ngIf="showExportButtons || showIncludeInactiveCheckbox">
        <div class="table-actions-left-content">
            <div class="action-icons" *ngIf="showExportButtons">
                <button type="button" (click)="onExportCsv()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M18.8139 6.96048L15.632 3.69125C15.5729 3.63055 15.5027 3.58242 15.4255 3.5496C15.3482 3.51679 15.2654 3.49993 15.1818 3.5H8.81818C8.48063 3.5 8.15691 3.63777 7.91823 3.88301C7.67955 4.12825 7.54545 4.46087 7.54545 4.80769V6.11538H6.27273C5.93518 6.11538 5.61146 6.25316 5.37277 6.4984C5.13409 6.74364 5 7.07626 5 7.42308V19.1923C5 19.5391 5.13409 19.8717 5.37277 20.117C5.61146 20.3622 5.93518 20.5 6.27273 20.5H15.1818C15.5194 20.5 15.8431 20.3622 16.0818 20.117C16.3205 19.8717 16.4545 19.5391 16.4545 19.1923V17.8846H17.7273C18.0648 17.8846 18.3885 17.7468 18.6272 17.5016C18.8659 17.2564 19 16.9237 19 16.5769V7.42308C19.0001 7.33719 18.9837 7.25213 18.9517 7.17275C18.9198 7.09338 18.8729 7.02125 18.8139 6.96048ZM15.1818 19.1923H6.27273V7.42308H12.3731L15.1818 10.309V19.1923ZM17.7273 16.5769H16.4545V10.0385C16.4546 9.95257 16.4382 9.86751 16.4063 9.78814C16.3743 9.70876 16.3275 9.63663 16.2684 9.57586L13.0866 6.30663C13.0274 6.24594 12.9572 6.1978 12.88 6.16499C12.8027 6.13217 12.72 6.11532 12.6364 6.11538H8.81818V4.80769H14.9185L17.7273 7.69361V16.5769ZM13.2727 13.9615C13.2727 14.1349 13.2057 14.3013 13.0863 14.4239C12.967 14.5465 12.8051 14.6154 12.6364 14.6154H8.81818C8.64941 14.6154 8.48755 14.5465 8.3682 14.4239C8.24886 14.3013 8.18182 14.1349 8.18182 13.9615C8.18182 13.7881 8.24886 13.6218 8.3682 13.4992C8.48755 13.3766 8.64941 13.3077 8.81818 13.3077H12.6364C12.8051 13.3077 12.967 13.3766 13.0863 13.4992C13.2057 13.6218 13.2727 13.7881 13.2727 13.9615ZM13.2727 16.5769C13.2727 16.7503 13.2057 16.9166 13.0863 17.0393C12.967 17.1619 12.8051 17.2308 12.6364 17.2308H8.81818C8.64941 17.2308 8.48755 17.1619 8.3682 17.0393C8.24886 16.9166 8.18182 16.7503 8.18182 16.5769C8.18182 16.4035 8.24886 16.2372 8.3682 16.1146C8.48755 15.992 8.64941 15.9231 8.81818 15.9231H12.6364C12.8051 15.9231 12.967 15.992 13.0863 16.1146C13.2057 16.2372 13.2727 16.4035 13.2727 16.5769Z"
                            fill="#4A6DFB" />
                    </svg>
                </button>

                <button type="button" (click)="onExportXlsx()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.5 4H14.4657L18.5 8.06255V20H5.5V4ZM6.94444 5.45455V18.5455H17.0556V9.81818H12.7222V5.45455H6.94444ZM14.1667 5.75564V8.36364H16.7566L14.1667 5.75564ZM14.1667 10.5455V11.7425C14.1667 11.9381 14.1275 12.1316 14.0516 12.3115C13.9756 12.4915 13.8645 12.6541 13.7247 12.7898L13.0407 13.4545L13.7247 14.1193C13.8645 14.255 13.9756 14.4176 14.0516 14.5976C14.1275 14.7775 14.1667 14.971 14.1667 15.1665V16.3636H12.7222V15.1665L12 14.4647L11.2778 15.1665V16.3636H9.83333V15.1665C9.83333 14.971 9.87247 14.7775 9.94841 14.5976C10.0244 14.4176 10.1355 14.255 10.2753 14.1193L10.9593 13.4545L10.2753 12.7898C10.1355 12.6541 10.0244 12.4915 9.94841 12.3115C9.87247 12.1316 9.83333 11.9381 9.83333 11.7425V10.5455H11.2778V11.7425L12 12.4444L12.7222 11.7425V10.5455H14.1667Z"
                            fill="#4A6DFB" />
                    </svg>
                </button>

                <button type="button" (click)="onExportPdf()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8.3 16H7.5V17H8.3C8.6 17 8.8 16.8 8.8 16.5C8.8 16.2 8.6 16 8.3 16ZM13.5 4H5.5V20H18.5V9L13.5 4ZM9.7 16.6C9.7 17.4 9.1 18 8.3 18H7.5V19H6.5V15H8.3C9.1 15 9.7 15.6 9.7 16.4V16.6ZM13.8 17.1C13.8 18.1 13 19 11.9 19H10.5V15H11.9C12.9 15 13.8 15.8 13.8 16.9V17.1ZM17.5 16H15.5V17H17V18H15.5V19H14.5V15H17.5V16ZM17.5 14H6.5V5H13.5V9H17.5V14ZM11.9 16H11.5V18H11.9C12.5 18 12.9 17.6 12.9 17C12.9 16.4 12.4 16 11.9 16Z"
                            fill="#4A6DFB" />
                    </svg>
                </button>

                <div class="vertical-divider" *ngIf="showIncludeInactiveCheckbox"></div>
            </div>

            <div class="include-inactive-container" *ngIf="showIncludeInactiveCheckbox">
                <p-checkbox [(ngModel)]="internalIncludeInactive" (ngModelChange)="onIncludeInactiveChange($event)"
                    [ngModelOptions]="{standalone: true}" [binary]="true" inputId="includeInactive">
                </p-checkbox>
                <label for="includeInactive" class="include-inactive-label">Show Inactives</label>
            </div>
        </div>
    </div>

    <div class="table-actions-right">
        <div class="header-actions" *ngIf="headerActions && headerActions.length > 0">
            <ng-container *ngFor="let action of headerActions">
                <button type="button" pButton [label]="action.label" [severity]="action.severity || 'primary'"
                    (click)="onHeaderActionClick(action)" [pTooltip]="action.tooltip || action.label"
                    tooltipPosition="top">
                </button>
            </ng-container>
        </div>

        <div class="pagination-buttons" *ngIf="showPagination">
            <button type="button" class="button-prev" (click)="loadPreviousPage()" [disabled]="pageIndex <= 1">
                <i class="pi pi-chevron-left"></i>
            </button>
            <button type="button" class="button-next" (click)="loadNextPage()" [disabled]="pageIndex >= totalPages">
                <i class="pi pi-chevron-right"></i>
            </button>
        </div>

        <p class="table-actions-text" *ngIf="showPagination">Total: {{ totalCount }}</p>



        <button type="button" class="filter-icon-btn" (click)="openFilterSidebar()" pTooltip="Columns preference"
            tooltipPosition="top">
            <span class="svg-icon-wrapper" [innerHTML]="getColumnPreferenceIcon()"></span>
        </button>

    </div>
</div>

<div id="table">
    <p-table #dt [value]="data" class="listing-table" [exportFilename]="exportFilename">
        <ng-template pTemplate="header" class="table-header">
            <tr>
                <th>S.No.</th>
                <ng-container *ngFor="let column of getVisibleColumns()">
                    <th [style.width]="column.width" [style.text-align]="column.align || 'left'">
                        {{ column.header }}
                    </th>
                </ng-container>
                <th class="" *ngIf="actions && actions.length > 0">
                    <span>Actions</span>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-i="rowIndex">
            <tr [ngClass]="{'row-even': i % 2 !== 0}">
                <td class="num">{{ (this.pageIndex - 1) * this.rowsPerPage + i + 1 }}</td>
                <ng-container *ngFor="let column of getVisibleColumns()">
                    <td [style.text-align]="column.align || 'left'">
                        {{ formatCellValue(rowData, column, column.customField) }}
                    </td>
                </ng-container>
                <td *ngIf="actions && actions.length > 0">
                    <div class="flex items-center gap-0">
                        <ng-container *ngFor="let action of actions">
                            @if(action.type === 'toggle') {
                            <p-toggleswitch [inputId]="action.key" [(ngModel)]="rowData.is_active"
                                (ngModelChange)="onActionClick(action, rowData, i)">
                            </p-toggleswitch>
                            } @else {
                            <button type="button" pButton [text]="true" [rounded]="true" class="icon-btn"
                                (click)="onActionClick(action, rowData, i)" [pTooltip]="action.tooltip || action.label"
                                tooltipPosition="top">
                                <ng-container *ngIf="action.svgIcon">
                                    <span class="svg-icon-wrapper" [innerHTML]="getSanitizedSvg(action.svgIcon)"></span>
                                </ng-container>
                                <ng-container *ngIf="!action.svgIcon && action.icon">
                                    <i [class]="action.icon"></i>
                                </ng-container>
                                <ng-container *ngIf="!action.svgIcon && !action.icon">
                                    {{ action.label }}
                                </ng-container>
                            </button>
                            }
                        </ng-container>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Filter Drawer -->
<p-drawer [(visible)]="displayFilterSidebar" position="right" [modal]="true" [dismissible]="true"
    styleClass="filter-drawer">
    <ng-template pTemplate="header">
        <div class="drawer-header">
            <span class="drawer-title">Column Preferences</span>
        </div>
    </ng-template>

    <div class="drawer-content">
        <div class="drawer-columns" cdkDropList (cdkDropListDropped)="dropColumn($event)">
            <div *ngFor="let column of getOrderedColumnsForPreference()" class="drawer-column-item" cdkDrag>
                <p-checkbox [binary]="true" [inputId]="column.key" [ngModel]="isColumnSelected(column.key)"
                    (ngModelChange)="toggleColumnSelection(column.key, $event)">
                </p-checkbox>
                <label [for]="column.key" class="column-label">{{ column.header }}</label>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="drawer-footer">
            <button type="button" pButton label="Clear" class="drawer-button drawer-cancel-button"
                (click)="clearColumnSelection()"></button>
            <button type="button" pButton label="Apply" class="drawer-button drawer-apply-button"
                (click)="applyColumnSelection()"></button>
        </div>
    </ng-template>
</p-drawer>